enum SortValue {
  FEATURED = 'FEATURED',
  MOST_RECENT = 'MOST_RECENT',
  NEAREST = 'NEAREST',
}

export default SortValue
